import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "done_active",
  "use": "done_active-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"done_active\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.3182 21.2388L6.82955 15.597L5 17.4776L12.3182 25L28 8.8806L26.1705 7L12.3182 21.2388Z\" fill=\"#219653\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol